import React from "react";
import { Link } from "react-router-dom";
import parse from "react-html-parser";

import "../assets/css/Ver.css";
import { useContext, useEffect } from "react";
import Contexto from "../context/Contexto";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import PlayerDevRock from "../components/PlayerDevRock";
import Izquierda from "../assets/CCstatics/fizquierda.png";
import Derecha from "../assets/CCstatics/fderecha.png";
import Visto from "../assets/CCstatics/visto.png";
import Check from "../assets/CCstatics/check.png";
import PlayNegro from "../assets/CCstatics/playNegro.png";
import Vistito from "../assets/CCstatics/vistito.png";
import Invisible from "../assets/CCstatics/invisible.png";
import Links from "../assets/CCstatics/link.png";
import Descarga from "../assets/CCstatics/descarga.png";
function Ver() {
  let rana = -1;
  const location = useLocation();
  const {
    buscarDataCurso,
    verCurso,
    cursoscomprados,
    Griseado,
    cliente,
    salvarProgreso,
  } = useContext(Contexto);
  const [infoCurso, setInfoCurso] = useState([]);
  const [verListado, setVerListado] = useState("none");
  const [videosVistos, setVideosVistos] = useState({});
  const [escuelas, setEscuelas] = useState({});
  const [adjuntos, setAdjuntos] = useState([]);
  const [actual, setActual] = useState({
    url: "https://player.vimeo.com/video/914282478",
    posicion: 0,
    fuevisto: false,
    nombre: ":)",
    descripcion: "Es hora de aprender...",
  });
  let pathCurso = location.pathname.substr(5);
  let unitivo = pathCurso.split("/");
  let cursoCorriendo;

  useEffect(() => {
    let data = actual;
    if (location.pathname.substr(5).split("/") == "designseason24") {
      data.url = "https://player.vimeo.com/video/914282478";

      setActual(data);
    }
    if (location.pathname.substr(5).split("/") == "designseason7") {
      data.url = "https://player.vimeo.com/video/948145500";

      setActual(data);
    }
    if (location.pathname.substr(5).split("/") == "designseason8") {
      data.url = "https://player.vimeo.com/video/948148797";
      setActual(data);
    }
    if (location.pathname.substr(5).split("/") == "designseason10") {
      data.url = "https://player.vimeo.com/video/1056548471";
      setActual(data);
    }
    if (location.pathname.substr(5).split("/") == "designseason9") {
      data.url = "https://player.vimeo.com/video/1000176076";
      setActual(data);
    }
    if (location.pathname.substr(5).split("/") == "designseasongym") {
      data.url = "https://player.vimeo.com/video/1056548471";
      setActual(data);
    }
  }, []);

  if (unitivo[0] == "color-club") {
    cursoCorriendo = unitivo[1] + "-" + unitivo[2];
  } else {
    cursoCorriendo = unitivo[0];
  }

  useEffect(() => {
    //console.log("cursoscomprados", cursoscomprados);
    if (cursoscomprados[unitivo[0]] != undefined) {
      if (cursoscomprados[unitivo[0]].estado) {
        buscarDataCurso(pathCurso);
      } else {
        Griseado("/renovaciones");
      }
    } else {
      Griseado("/comprar/designseason");
    }
    setEscuelas(unitivo);
  }, [cursoscomprados]);
  useEffect(() => {
    if (cliente) {
      if (cliente.hasOwnProperty("progreso")) {
        if (cliente.progreso.hasOwnProperty(cursoCorriendo)) {
          if (cliente.progreso[cursoCorriendo].hasOwnProperty("videosVistos")) {
            if (cliente.progreso[cursoCorriendo].videosVistos.length > 0) {
              setVideosVistos(cliente.progreso[cursoCorriendo]);
            }
          } else {
            setVideosVistos({
              total: 0,
              ultimaVivisita: Date.now(),
              videosVistos: [],
            });
          }
        } else {
          setVideosVistos({
            total: 0,
            ultimaVivisita: Date.now(),
            videosVistos: [],
          });
        }
      } else {
        setVideosVistos({
          total: 0,
          ultimaVivisita: Date.now(),
          videosVistos: [],
        });
      }
    }

    if (verCurso != null) {
      preparaAdjuntos(verCurso[1]);
      setInfoCurso(verCurso);
    }
  }, [verCurso]);
  const preparaAdjuntos = (valores) => {
    let claves = Object.keys(valores);
    let adj = [];
    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      adj.push(valores[clave]);
    }
    setAdjuntos(adj);
  };
  const play = (e) => {
    let laURL = e.target.attributes.url.value;

    let estadito = e.target.classList.contains("visto");
    let videoActual = {
      url: laURL,
      posicion: parseInt(e.target.attributes.posicion.value),
      fuevisto: estadito,
      nombre: e.target.attributes.nombre.value,
      descripcion:
        infoCurso[parseInt(e.target.attributes.posicion.value)].descripcion,
    };
    setActual(videoActual);
    let enplay = document.querySelectorAll(".enPlay");
    enplay.forEach((box) => {
      box.classList.remove("enPlay");
    });
    e.target.classList.add("enPlay");
    if (verListado == "block") {
      setVerListado("none");
    } else {
      setVerListado("block");
    }
    VerListado();
    //   window.open(laURL, "_blank").focus();
  };

  useEffect(() => {
    if (unitivo[3] && infoCurso.length > 0) {
      let numeroAjustado = parseInt(unitivo[3]) + 1;
      const videoActual = {
        url: infoCurso[numeroAjustado].url,
        nombre: infoCurso[numeroAjustado].nombre,
        posicion: numeroAjustado,
        fuevisto: "",
        descripcion: infoCurso[numeroAjustado].descripcion,
      };
      let laURL = infoCurso[numeroAjustado].url;

      setActual(videoActual);
    }
  }, [infoCurso]);

  const marcarVistoBTN = (e) => {
    let vv = videosVistos;
    let puntaje = verCurso[0].puntaje;

    if (vv.videosVistos.indexOf(actual.url) == -1) {
      vv.videosVistos.push(actual.url);
    }

    let activos = document.querySelectorAll("#pepeLoco li button");
    activos[actual.posicion].classList.add("visto");

    vv.ultimaVivisita = Date.now();
    vv.total = (100 / parseInt(puntaje)) * vv.videosVistos.length;
    salvarProgreso(cursoCorriendo, vv);

    let ActualActualizado = actual;
    ActualActualizado.fuevisto = true;
    setActual(ActualActualizado);
  };

  const pasarSiguiente = () => {
    let pepe = document.getElementById("pepeLoco");
    let activos = pepe.querySelectorAll("li button span");
    // console.log(
    //   "actual.posicion:",
    //   actual.posicion,
    //   "activos.length:",
    //   activos.length
    // );
    if (actual.posicion < activos.length - 1) {
      let siguiente = actual.posicion;
      siguiente++;
      let estadito = activos[siguiente].classList.contains("visto");

      let videoActual = {
        url: activos[siguiente].attributes.url.value,
        posicion: parseInt(activos[siguiente].attributes.posicion.value),
        fuevisto: estadito,
        nombre: activos[siguiente].attributes.nombre.value,
        descripcion: infoCurso[siguiente + 2].descripcion,
      };
      let laURL = activos[siguiente].attributes.url.value;

      let enplay = document.querySelectorAll(".enPlay");
      enplay.forEach((box) => {
        box.classList.remove("enPlay");
      });
      activos[siguiente].classList.add("enPlay");
      setActual(videoActual);
    }
  };
  const volverAnterior = () => {
    let pepe = document.getElementById("pepeLoco");
    let activos = pepe.querySelectorAll("li button span");
    if (actual.posicion > 0) {
      let nuevaposicion = actual.posicion;

      nuevaposicion--;
      let estadito = activos[nuevaposicion].classList.contains("visto");

      const videoActual = {
        url: activos[nuevaposicion].attributes.url.value,
        nombre: activos[nuevaposicion].attributes.nombre.value,

        posicion: nuevaposicion,
        fuevisto: estadito,
        descripcion: infoCurso[nuevaposicion + 2].descripcion,
      };
      let laURL = activos[nuevaposicion].attributes.url.value;

      setActual(videoActual);
      let enplay = document.querySelectorAll(".enPlay");
      enplay.forEach((box) => {
        box.classList.remove("enPlay");
      });
      activos[nuevaposicion].classList.add("enPlay");
    }
  };
  const [verAdj, setVerAdj] = useState("none");
  const VerListado = () => {
    setInfoCurso(verCurso);
    if (verListado == "block") {
      setVerListado("none");
    } else {
      setVerListado("block");
    }
    setVerAdj("none");
  };
  const verAdjuntos = () => {
    setVerListado("none");
    if (verAdj == "block") {
      setVerAdj("none");
    } else {
      setVerAdj("block");
    }
  };
  let abrir = (laURL) => {
    window.open(laURL, "_blank").focus();
  };

  return (
    <>
      <section className="verSection">
        <div className="soporteVideos">
          <div className="controlitos">
            {escuelas[0] == "color-club" ? (
              <>
                <Link
                  to={`/escuela/${escuelas[1]}`}
                  className="volver"
                >{`< Volver a Escuela de ${escuelas[1]}`}</Link>
                <p className="tituloEscuela">Escuela de {escuelas[1]}</p>
              </>
            ) : (
              <>
                {infoCurso[0] && (
                  <p className="tituloEscuela">{infoCurso[0].nombre}</p>
                )}
                <Link to={"/miscursos"}>{`< Volver a Mis cursos`}</Link>
              </>
            )}

            <p className="tituloVideo">{actual.nombre}</p>
          </div>
          <div className="videou">
            <PlayerDevRock
              videoURL={actual.url}
              className="playerDR"
            ></PlayerDevRock>
          </div>
          <p className="contieneDescripcion">{parse(actual.descripcion)}</p>

          <div className="controlesLocos">
            <div className="control">
              <img
                onClick={volverAnterior}
                src={Izquierda}
                alt=""
                className="flechas"
              />
              <label>Anterior</label>
            </div>
            <div className="vistos">
              {actual.fuevisto ? (
                <img src={Check} alt="" />
              ) : (
                <img src={Visto} alt="" onClick={marcarVistoBTN} />
              )}

              <label htmlFor="quieroNews">Marcar como visto</label>
              {/*   */}
            </div>
            <div className="control">
              <img
                src={Derecha}
                alt=""
                onClick={pasarSiguiente}
                className="flechas"
              />
              <label>Siguiente</label>
            </div>
          </div>
        </div>

        <div className="listadoNuevo">
          <li className="titlist">Contenidos</li>

          <ul id="pepeLoco">
            {infoCurso &&
              infoCurso.map((item, i) => {
                if (item.url != undefined) {
                  rana++;
                }
                if (item.hasOwnProperty("nombre") && i > 1) {
                  let estado = "";
                  let busqueda = videosVistos.videosVistos.indexOf(item.url);
                  if (busqueda >= 0) {
                    estado = "visto";
                  }

                  return (
                    <>
                      {item.url ? (
                        <li key={`${i}-videitos`}>
                          <button>
                            <span
                              onClick={play}
                              url={item.url}
                              nombre={item.nombre}
                              tipo={item.tipo}
                              posicion={rana}
                              className={estado}
                            >
                              <img
                                src={PlayNegro}
                                alt=""
                                onClick={play}
                                url={item.url}
                                nombre={item.nombre}
                                tipo={item.tipo}
                                posicion={rana}
                                className={estado}
                              />
                              {item.nombre}
                            </span>
                            {item.duracion}
                          </button>
                          {estado == "visto" ? (
                            <img src={Vistito} alt="" />
                          ) : (
                            <img src={Invisible} alt="" />
                          )}
                        </li>
                      ) : (
                        <>
                          <p className="titilo-listadito">{item.nombre}</p>
                        </>
                      )}
                    </>
                  );
                }
              })}
          </ul>
          <li className="titlist">Links y Descargas</li>

          <ul className="adjuntos">
            {adjuntos &&
              adjuntos.map((item, i) => {
                return (
                  <li key={`${i}-adjuntos`}>
                    <button
                      onClick={() => {
                        abrir(item.url);
                      }}
                      url={item.url}
                    >
                      {item.tipo == "link" ? (
                        <img src={Links} alt="" />
                      ) : (
                        <img src={Descarga} alt="" />
                      )}
                      {item.nombre}
                    </button>
                  </li>
                );
              })}
          </ul>
        </div>
      </section>
    </>
  );
}

export default Ver;
